<template>
  <div>
    <van-tabbar v-model="appTabFooterActive">
      <van-tabbar-item @click="openShopping()" name="repairing" icon="point-gift-o">商城</van-tabbar-item>
      <van-tabbar-item to="/gameList" name="search" icon="search">球局</van-tabbar-item>
      <div class="tag_btn_FX">
        <van-tabbar-item
          to="/"
          class="tag_btn"
          name="home"
          :style="{ backgroundImage: 'url(' + require('../assets/golfouritLogo2.png') + ') ' }"
        ></van-tabbar-item>
      </div>

      <van-tabbar-item to="/noticePage" name="notice" icon="envelop-o" :html="getUserAllMailMessageLength"
        >通知</van-tabbar-item
      >
      <!-- <van-tabbar-item to="/gameManagement" name="friends" icon="friends-o">标签</van-tabbar-item> -->

      <van-tabbar-item to="/userSetting" name="setting" icon="setting-o">我的</van-tabbar-item>
    </van-tabbar>

    <van-dialog v-model="showDialog" title="本頁面開發中，敬請期待" :confirmButtonText="'確認'"></van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    appTabFooterActive: {
      get() {
        return this.$store.state.appTabFooterActive;
      },
      set(value) {
        if (value == "repairing") return;
        this.$store.commit("setAppTabFooterActive", value);
      },
    },
    userAllMailMessage() {
      return this.$store.getters.userAllMailMessage;
    },
    getUserAllMailMessageLength() {
      if (this.userAllMailMessage) {
        let sum = 0;
        for (let i in this.userAllMailMessage) {
          sum += this.userAllMailMessage[i].messageSum;
        }
        return { badge: sum };
      }
      return {};
    },
  },
  methods: {
    repairing() {
      this.showDialog = true;
    },
    openShopping() {
      this.$liff.openWindow({
        url: "https://liff.line.me/1656069848-6MJ3xDW8",
        external: false,
      });
    },
  },
};
</script>

<style scoped>
.van-tabbar {
  margin-top: auto;
}
.tag_btn_FX {
  background-color: #ffffff;
  position: relative;
  width: 50px;
}
.tag_btn {
  background-color: #ffffff;
  position: absolute;
  width: 55px;
  height: 55px;
  top: -10px;
  border-radius: 50%;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  z-index: 99;
}
</style>
